import classNames from 'classnames';
import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { MdDeleteOutline, MdGroupWork } from 'react-icons/md';
import { Button, Table } from 'rsuite';
import type { TableColumnProps } from 'rsuite/lib/Table/TableColumn';
import { ProdutoDetalhado } from '../../hooks/useProdutosCampanha';
import styles from './ModalOfferTable.module.scss';

const Column = Table.Column as React.ComponentType<React.PropsWithChildren<TableColumnProps>>;
const HeaderCell = Table.HeaderCell;
const Cell = Table.Cell;

type IRowData = Partial<ProdutoDetalhado>;

interface ModalOfferTableProps {
  data: IRowData[];
  idsLojas: any[];
  sortColumn?: string;
  sortType?: 'asc' | 'desc';
  onSortColumn?: (sortColumn: string, sortType: 'asc' | 'desc') => void;
  onRemoveProduct: (rowData: IRowData, index?: number) => void;
}

export const ModalOfferTable = ({ data, sortColumn, sortType, onSortColumn, onRemoveProduct }: ModalOfferTableProps) => {
  if (!data || data.length === 0) return null;

  return (
    <div className={styles.container}>
      <Table
        key="modal-offer-table"
        className={styles.table}
        headerHeight={50}
        data={data}
        height={230}
        sortColumn={sortColumn}
        sortType={sortType}
        onSortColumn={onSortColumn}
        autoHeight={false}
        style={{ width: '100%', tableLayout: 'fixed' }}
      >
        <Column align="left" verticalAlign="middle" width={248} flexGrow={1}>
          <HeaderCell>Produto</HeaderCell>
          <Cell>
            {(rowData: IRowData) => (
              <div className={styles['product-cell']}>
                <div className={styles['product-info']}>
                  <span className={styles['product-id']}>{rowData.product_id}</span>
                  {rowData.product_family_id ? (
                    <div className={styles['store-badge']}>
                      <MdGroupWork />
                      <span>{rowData.product_family_id}</span>
                    </div>
                  ) : null}
                </div>
                <span className={styles['product-description']}>{rowData.description}</span>
              </div>
            )}
          </Cell>
        </Column>

        <Column align="left" verticalAlign="middle" width={96}>
          <HeaderCell>
            <div className={styles['header-cell']}>
              <span>Preço</span>
              <span>regular</span>
            </div>
          </HeaderCell>
          <Cell>
            {(rowData: IRowData) => {
              const calcPreco = rowData.retail_price ? rowData.retail_price : '';
              return (
                <span className={styles['default-cell']}>
                  {calcPreco ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={calcPreco}
                      displayType="text"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )}
                </span>
              );
            }}
          </Cell>
        </Column>

        <Column width={200}>
          <HeaderCell>
            <div className={styles['header-cell']}>
              <span>Preço</span>
              <span>concorrência</span>
            </div>
          </HeaderCell>
          <Cell>
            {(rowData: IRowData) => {
              const calcPreco = rowData.avg_competitiveness_price ? rowData.avg_competitiveness_price : '';
              return (
                <span className={styles['default-cell']}>
                  {calcPreco ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={calcPreco}
                      displayType="text"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )}
                </span>
              );
            }}
          </Cell>
        </Column>

        <Column align="left" verticalAlign="middle" width={96}>
          <HeaderCell>CPI</HeaderCell>
          <Cell>
            {(rowData: IRowData) => {
              const hasOfferPriceCpi = rowData.offer_price_cpi !== null && rowData.offer_price_cpi !== undefined;
              return (
                <span className={styles['default-cell']}>
                  {hasOfferPriceCpi ? (
                    <CurrencyFormat decimalScale={2} value={rowData.offer_price_cpi} displayType="text" suffix="%" decimalSeparator="," thousandSeparator="." />
                  ) : (
                    '--'
                  )}
                </span>
              );
            }}
          </Cell>
        </Column>

        <Column align="left" verticalAlign="middle" width={80}>
          <HeaderCell>Margem</HeaderCell>
          <Cell>
            {(rowData: IRowData) => {
              const hasMargin = rowData.margin_price_retail !== null && rowData.margin_price_retail !== undefined;
              return (
                <span className={styles['default-cell']}>
                  {hasMargin ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={1}
                      value={rowData.margin_price_retail}
                      displayType="text"
                      suffix="%"
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )}
                </span>
              );
            }}
          </Cell>
        </Column>

        <Column align="right" verticalAlign="middle" width={50} fixed="right">
          <HeaderCell />
          <Cell>
            {(rowData: IRowData) => (
              <span className={classNames(styles['action-cell'])}>
                <Button title="Deletar" size="md" onClick={() => onRemoveProduct(rowData)}>
                  <MdDeleteOutline title="Deletar" size="md" />
                </Button>
              </span>
            )}
          </Cell>
        </Column>
      </Table>
    </div>
  );
};
